import { ChangeEvent, forwardRef, LegacyRef, useState } from "react"
import { Input } from "@gogoro/go-design"
import { Search } from "@styled-icons/feather/Search"
import classnames from "classnames"

import { SearchInputProps } from "./SearchInputProps"

import styles from "./styles.module.scss"

const SearchInput = (
  { className, onSearch, onChange, value, error, disabled, testId = "", ...restProps }: SearchInputProps,
  ref: LegacyRef<HTMLInputElement>,
) => {
  const [onFocus, setOnFocus] = useState(false)

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    onChange(value, e)
  }

  return (
    <div className={styles.container} data-testid={testId}>
      <Input
        ref={ref}
        error={error}
        className={classnames(styles.input, className)}
        onChange={handleOnChange}
        {...restProps}
        onFocusCapture={() => setOnFocus(true)}
        onBlurCapture={() => setOnFocus(false)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onSearch(value)
          }
        }}
        disabled={disabled}
        value={value}
      />
      <span
        className={classnames(styles.icon, {
          [styles["icon-focus"]]: onFocus,
          [styles["icon-error"]]: error,
          [styles["icon-disabled"]]: disabled,
        })}
        onClick={() => onSearch(value)}
        data-testid={`${testId}-search-btn`}
        role="button">
        <Search />
      </span>
    </div>
  )
}

export default forwardRef(SearchInput)
